<template>
    <div class="person-page">
        <!-- 人员编号搜索区域 -->
        <div class="search-bar">
            <el-input placeholder="人员编号" v-model="personCode" style="width: 150px; margin-right: 10px;" clearable
                @keyup.enter.native="handleQuery"></el-input>
            <el-button type="primary" @click="handleQuery" :loading="queryLoading">查询</el-button>
            <el-button @click="handleReset" style="margin-left: 10px;">重置</el-button>
        </div>

        <!-- 人员列表表格 -->
        <el-table :data="personList" border style="width: 100%;"
            :header-cell-style="{ background: '#f5f7fa', color: '#333' }" v-loading="tableLoading"
            empty-text="暂无人员信息数据">
            <el-table-column label="序号" width="60" align="center" :formatter="formatIndex"></el-table-column>
            <el-table-column prop="userId" label="人员编号" min-width="100" align="center"></el-table-column>
            <el-table-column prop="userName" label="人员姓名" min-width="100" align="center"></el-table-column>
            <el-table-column prop="phone" label="手机号" min-width="120" align="center">
                <template slot-scope="scope">
                    {{ formatPhone(scope.row.phone) }}
                </template>
            </el-table-column>
            <el-table-column prop="state" label="状态" width="80" align="center">
                <template slot-scope="scope">
                    <!-- 核心修改：判断数值1/0，显示对应文本和标签类型 -->
                    <el-tag :type="scope.row.state == 1 || scope.row.state == '1' ? 'success' : 'danger'" size="small">
                        {{ scope.row.state == 1 || scope.row.state == '1' ? '正常' : '异常' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="personAccount" label="个人账户余额" min-width="140" align="center">

            </el-table-column>
            <el-table-column prop="subsidyAccount" label="补贴账户余额" min-width="140" align="center">

            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container" style="margin-top: 20px; text-align: right;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagination.pageSize"
                layout="total, prev, pager, next, ->, sizes" :total="pagination.totalCount" background
                :disabled="pagination.totalCount === 0"></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PersonList',
    data() {
        return {
            personCode: '', // 人员编号
            queryLoading: false, // 查询按钮加载状态
            tableLoading: false, // 表格加载状态
            personList: [], // 人员列表数据
            // 分页参数
            pagination: {
                currentPage: 1, // 当前页码
                pageSize: 10,   // 每页条数
                totalCount: 0   // 总条数
            }
        };
    },
    created() {
        // 初始化加载第一页数据
        this.getUserInfoList();
    },
    methods: {
        // 格式化序号（分页后正确显示）
        formatIndex(row, column) {
            console.log(column);

            return (this.pagination.currentPage - 1) * this.pagination.pageSize + (this.personList.indexOf(row) + 1);
        },

        // 手机号格式化（中间4位隐藏）
        formatPhone(phone) {
            if (!phone || phone.length !== 11) return phone || '暂无';
            return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
        },

        // 金额格式化（保留两位小数）
        formatAmount(amount) {
            return (Number(amount) || 0).toFixed(2);
        },

        // 获取人员信息列表
        async getUserInfoList() {
            this.tableLoading = true;
            try {
                const url = 'https://www.zhongyanzhiye.com:8090/chelmeyAI/openAPI/selectUserInfo';

                // 构造请求参数
                const requestParams = {
                    pageNum: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize,
                    personCode: this.personCode.trim() // 人员编号查询条件
                };

                // 发送POST请求
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        // 如需Token认证，添加以下配置
                        // 'Authorization': 'Bearer ' + localStorage.getItem('token')
                    },
                    body: JSON.stringify(requestParams)
                });

                if (!response.ok) {
                    throw new Error(`接口请求失败: ${response.status}`);
                }

                const result = await response.json();

                // 处理接口返回数据（假设格式：{ code: 200, result: { rows: [], total: 0 }, message: '' }）

                this.personList = result.result.rows || [];
                this.pagination.totalCount = result.result.total || 0;


                console.log('人员信息数据:', result);

            } catch (error) {
                console.error('获取人员信息失败:', error);
                this.personList = [];
                this.pagination.totalCount = 0;
                this.$message.error('加载数据失败，请检查网络或稍后重试');
            } finally {
                this.tableLoading = false;
                this.queryLoading = false;
            }
        },

        // 查询按钮点击事件
        handleQuery() {
            this.queryLoading = true;
            this.pagination.currentPage = 1; // 重置为第一页
            this.getUserInfoList();
        },

        // 重置按钮点击事件
        handleReset() {
            this.personCode = ''; // 清空人员编号
            this.pagination.currentPage = 1;
            this.getUserInfoList();
        },

        // 每页条数改变
        handleSizeChange(val) {
            this.pagination.pageSize = val;
            this.pagination.currentPage = 1; // 重置页码
            this.getUserInfoList();
        },

        // 当前页码改变
        handleCurrentChange(val) {
            this.pagination.currentPage = val;
            this.getUserInfoList();
            // 滚动到表格顶部
            window.scrollTo(0, 200);
        }
    }
};
</script>

<style lang="scss" scoped>
.person-page {
    padding: 20px;
    background-color: #fff;
    min-height: calc(100vh - 40px);

    .search-bar {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
}

// 分页容器样式
.pagination-container {
    ::v-deep .el-pagination {
        --el-pagination-text-color: #666;
        --el-pagination-button-color: #409eff;
        --el-pagination-button-hover-color: #66b1ff;
    }
}

// 加载状态样式
::v-deep .el-loading-mask {
    background-color: rgba(255, 255, 255, 0.8);
}

::v-deep .el-loading-spinner {
    top: 45%;
}

// 表格样式优化
::v-deep .el-table {
    --el-table-row-hover-bg-color: #f8f9fa;
    --el-table-header-text-color: #333;
    --el-table-header-font-weight: 500;
}

// 状态标签样式优化
::v-deep .el-tag--success {
    --el-tag-bg-color: #f0f9ff;
    --el-tag-text-color: #13ce66;
    --el-tag-border-color: #e1f5fe;
}

::v-deep .el-tag--danger {
    --el-tag-bg-color: #fff2f0;
    --el-tag-text-color: #ff4d4f;
    --el-tag-border-color: #ffccc7;
}
</style>